import React from "react";
import { Box, Typography, Container, Button } from "@mui/material";

const YouTubeDescriptionExtractorContent = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Container maxWidth="md" sx={{ textAlign: "center", mt: 4 }}>
      {/* Introduction */}
      <Typography
        variant="h4"
        fontWeight="bold"
        sx={{ fontSize: "1.75rem" }}
        gutterBottom
      >
        Extract YouTube Video Descriptions in Seconds
      </Typography>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Discover the Metadata Behind Any YouTube Video
      </Typography>
      <Typography variant="body1" paragraph>
        Tired of manually copying video details for SEO, content planning, or
        analysis? Our Youtube title and description extractor simplifies your workflow by
        fetching titles, descriptions, tags, channel info, and more — instantly.
      </Typography>
      <Typography variant="body1" paragraph>
        Whether you're a marketer, creator, or researcher, extract detailed
        YouTube metadata with just a URL — no extensions or software needed.
      </Typography>

      {/* Features */}
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Why Use the YouTube Video Description Extractor?
      </Typography>
      <ul style={{ textAlign: "left", display: "inline-block" }}>
        <li>🔍 Instantly Extract Title, Description, Tags, and Upload Date.</li>
        <li>⚡ Save Time with One-Click Metadata Extraction.</li>
        <li>📈 Boost SEO by Analyzing Top-Performing Video Content.</li>
        <li>🔗 Copy or Download Metadata for Your Own Videos & Research.</li>
      </ul>

      {/* How It Works */}
      <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
        How to Extract YouTube Descriptions & Tags
      </Typography>
      <ol style={{ textAlign: "left", display: "inline-block" }}>
        <li>Copy a YouTube video URL from your browser.</li>
        <li>Log in to MyFreshTools and open the Description Extractor tool.</li>
        <li>Paste the video link and click "Extract Description." </li>
        <li>View or copy the title, description, tags, and upload details instantly.</li>
      </ol>

      {/* FAQs */}
      <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
        Frequently Asked Questions (FAQs)
      </Typography>

      <Typography variant="body1" fontWeight="bold">
        📄 What information does it extract?
      </Typography>
      <Typography variant="body2" paragraph>
        Title, description, tags, channel name, and upload date.
      </Typography>

      <Typography variant="body1" fontWeight="bold">
        🎯 How accurate is the data?
      </Typography>
      <Typography variant="body2" paragraph>
        100% accurate — pulled directly from YouTube’s metadata.
      </Typography>

      <Typography variant="body1" fontWeight="bold">
        💡 Can I extract data from other creators’ videos?
      </Typography>
      <Typography variant="body2" paragraph>
        Yes, just paste the public video URL to get metadata.
      </Typography>

      <Typography variant="body1" fontWeight="bold">
        🔐 Do I need to sign in?
      </Typography>
      <Typography variant="body2" paragraph>
        Yes, sign-in is required to track usage and credit consumption.
      </Typography>

      <Typography variant="body1" fontWeight="bold">
        💰 Is this tool free to use?
      </Typography>
      <Typography variant="body2" paragraph>
        Free users get limited extractions. Upgrade for unlimited access.
      </Typography>

      <Typography variant="body1" fontWeight="bold">
        🌐 Can I extract metadata on mobile?
      </Typography>
      <Typography variant="body2" paragraph>
        Absolutely! Our tool works smoothly on desktop, tablet, and mobile.
      </Typography>

      <Typography variant="body1" fontWeight="bold">
        📝 Can I download the extracted metadata?
      </Typography>
      <Typography variant="body2" paragraph>
        Yes, simply copy the content or export to use in your documents.
      </Typography>

      <Typography variant="body1" fontWeight="bold">
        🚀 Why should I upgrade?
      </Typography>
      <Typography variant="body2" paragraph>
        Upgraded users enjoy unlimited extractions, priority support, and advanced
        metadata insights for deep analysis.
      </Typography>

      {/* Call to Action */}
      <Box mt={4}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={scrollToTop}
        >
          Try It Now
        </Button>
      </Box>
    </Container>
  );
};

export default YouTubeDescriptionExtractorContent;